import { render, staticRenderFns } from "./beforeTbmRiskPop.vue?vue&type=template&id=2ac684aa"
import script from "./beforeTbmRiskPop.vue?vue&type=script&lang=js"
export * from "./beforeTbmRiskPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ac684aa')) {
      api.createRecord('2ac684aa', component.options)
    } else {
      api.reload('2ac684aa', component.options)
    }
    module.hot.accept("./beforeTbmRiskPop.vue?vue&type=template&id=2ac684aa", function () {
      api.rerender('2ac684aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sai/tbm/beforeTbmRiskPop.vue"
export default component.exports